import { render } from "./BoardingPassTicket.vue?vue&type=template&id=06209de5&scoped=true"
import script from "./BoardingPassTicket.vue?vue&type=script&lang=js"
export * from "./BoardingPassTicket.vue?vue&type=script&lang=js"

import "./BoardingPassTicket.vue?vue&type=style&index=0&id=06209de5&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06209de5"]])

export default __exports__